export const certifications = [
  {
    id: 1,
    title: 'UiPath Academy Automation Developer Professional Training',
    organization: 'UiPath',
    date: 'Jun 2025',
    expiryDate: 'Jun 2027',
    description: 'Advanced certification in Robotic Process Automation development and deployment',
    link: 'https://credentials.uipath.com/32f209ef-2895-4c62-ba34-f07021f6fa9c#acc.FjqdGQLi',
    credentialId: '32f209ef-2895-4c62-ba34-f07021f6fa9c',
    skills: ['UiPath Studio', 'Process Automation', 'Workflow Design', 'Exception Handling','State machines', 'REFramework','Remote Debugging','Advanced UI automation','Solution Accelerators'],
    verified: true
  },
  {
    id: 2,
    title: 'IBM SkillsBuild Internship - Frontend Web Development',
    organization: 'IBM SkillsBuild',
    date: 'Aug 2024',
    description: 'Successfully completed a 6-week internship focused on Frontend Web Development, gaining hands-on experience in modern web technologies, UI development, and collaborative project workflows.',
    link: 'https://drive.google.com/file/d/1LYyZ8FAY-Y7fse00oSF5b-vKk1t8EhNj/view?usp=drive_link', 
    credentialId: '1oOzPcWxQSf_ZRc8EN2BYu-iKb0ayPVFR',
    skills: ['Frontend Development', 'HTML', 'CSS', 'JavaScript', 'UI Design', 'Team Collaboration'],
    verified: true
  },
  {
    id: 3,
    title: 'Full Stack Web Development',
    organization: 'Udemy',
    date: 'Oct 2024',
    description: 'Comprehensive certification covering HTML, CSS, JavaScript, Node.js, MongoDB, and React.js',
    link: 'https://www.udemy.com/certificate/UC-56a1c203-0ede-480f-93db-beeef2b60437/',
    credentialId: 'UC-56a1c203-0ede-480f-93db-beeef2b60437',
    skills: ['HTML', 'CSS', 'JavaScript', 'React.js', 'Node.js','Express.js','MongoDB'],
    verified: true
  },
  {
    id: 4,
    title: 'C++ Programming - Beginner to Advance - Deep Dive in C++',
    organization: 'Udemy',
    date: 'Oct 2024',
    description: 'Comprehensive C++ certification covering basics to advanced topics including object-oriented programming, STL, memory management, and real-world project development.',
    link: 'https://www.udemy.com/certificate/UC-ab090b1b-93fd-4385-9260-f94acfa74474/',
    credentialId: 'UC-ab090b1b-93fd-4385-9260-f94acfa74474',
    skills: ['C++', 'OOP', 'STL', 'Pointers', 'Memory Management', 'File Handling', 'Inheritance', 'Polymorphism'],
    verified: true
  },
  {
    id: 5,
    title: 'Introduction to Generative AI',
    organization: 'Coursera',
    date: 'May 2024',
    description: 'Introductory course on generative artificial intelligence concepts, including large language models (LLMs), prompt engineering, and real-world AI applications.',
    link: 'https://www.coursera.org/account/accomplishments/verify/BT2DCCKRJFJ8',
    credentialId: 'BT2DCCKRJFJ8',
    skills: ['Generative AI', 'Large Language Models', 'Prompt Engineering', 'AI Ethics', 'Machine Learning Basics'],
    verified: true
  },
  {
    id: 6,
    title: 'Artificial Intelligence and Machine Learning',
    organization: 'Ybi Foundation',
    date: 'Nov 2023',
    description: 'Comprehensive certification covering core concepts of artificial intelligence and machine learning, including supervised and unsupervised learning, neural networks, and real-world model implementation.',
    link: 'https://foundationybi.trainercentralsite.in/certificate-validation?credentialId=Q3SIX934HKSES',
    credentialId: 'Q3SIX934HKSES',
    skills: ['Machine Learning', 'Artificial Intelligence', 'Supervised Learning', 'Unsupervised Learning', 'Neural Networks', 'Model Evaluation'],
    verified: true
  },
  {
    id: 7,
    title: 'HTML5 with JavaScript & CSS3: Adaptive AI, Graphics, & Animation',
    organization: 'Infosys Springboard',
    date: 'Oct 2023',
    description: 'A certification focused on building dynamic and visually engaging web interfaces using HTML5, JavaScript, and CSS3. Topics include responsive design, graphics rendering, animations, and adaptive behaviors in web applications.',
    link: 'https://drive.google.com/file/d/1e1FT-cyIcIGQEKVpgvW7Oj08O4kJQv7V/view?usp=drive_link',
    credentialId: 'FCC-JS-12345',
    skills: ['HTML5', 'CSS3', 'JavaScript', 'Responsive Design', 'Canvas & SVG', 'Web Animation', 'Interactive UI'],
    verified: true
  },
  {
    id: 8,
    title: 'Developer Job Simulation',
    organization: 'Accenture',
    date: 'Oct 2023',
    description: 'Completed practical tasks including defining technical requirements, debugging, unit testing, user acceptance testing, cloud infrastructure scaling, and security assessments as part of a real-world developer job simulation.',
    link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Accenture%20Nordics/PxenP4rHNE6Bh4nQz_Accenture%20Nordics_jKvpMtM4kaW6ECCFA_1697573138125_completion_certificate.pdf',
    credentialId: 'sNiAzjMWCYKRXooZT',
    skills: [
      'Technical Requirements Analysis', 'Architecture Design', 'Cloud Infrastructure',
      'Debugging', 'Unit Testing', 'UAT', 'Security Assessment', 'IAM Policies',
      'SDLC Security', 'Data Privacy'
    ],
    verified: true
  }
];
